<template>
  <div class="container">
    <div class="clearfix">
      <Form @submit.native.prevent :model="formData" label-position="left"  class="mytable-titleBox fl">
        <div class="clearfix">
          <FormItem label="标题 :" class="fl mytable-title" :label-width="48">
            <Input v-model="formData.input1"></Input>
          </FormItem>
          <FormItem label="购买人昵称 :" class="fl mytable-title" :label-width="94">
            <Input v-model="formData.input2"></Input>
          </FormItem>
          <FormItem v-if="isAdmin===1" label="作者昵称 :" class="fl mytable-title" :label-width="84">
            <Input v-model="formData.input3"></Input>
          </FormItem>
          <div class="fl checkReset">
            <Button type="primary" class="fl" @click="handleSearch">查询</Button>
            <Button class="fl" @click="reset">重置</Button>
          </div>
          <FormItem class="fr" :label-width="84" v-model="income">
            <div class="fr income"><span class="mr10">总计<b>￥{{income}}</b></span><span class="mr10">手续费<b> ￥{{(income*6/1000).toFixed(2)}}</b></span><span class="mr10">结余费<b> ￥{{(income - (income*6/1000).toFixed(2)).toFixed(2)}}</b></span></div>
          </FormItem>

        </div>
        <div class="mt24">
          <FormItem label="日期范围:" :label-width="72" class="fl mytable-title">
            <DatePicker v-model="formData.date" @on-change="formData.date=$event" class="w240" type="daterange" format="yyyy-MM-dd" placeholder="开始日期 ~ 结束日期"></DatePicker>
          </FormItem>
        </div>
      </Form>
    </div>
    <Table :loading="tableLoading" class="mt24" :columns="columns1" :data="tableData"></Table>
    <Page class="mt24" :total="total" :current="page_num" show-elevator show-sizer show-total @on-page-size-change="handleSizeChange" @on-change="handlePageChange"/>
  </div>

</template>

<script>
import mixins from '@/mixins/page'
export default {
  mixins: [mixins],
  name: 'order_manage',
  data () {
    return {
      isAdmin: Number(localStorage.getItem('sa')),
      formItem: {
        input: '',
        select: '',
        radio: 'male',
        checkbox: [],
        switch: true,
        time: '',
        slider: [20, 50],
        textarea: ''
      },
      page_num: 1,
      page_size: 10,
      tableData: [],
      modalLoading: true,

      income: '',
      formData: {
        date: []
      },
      formData1: {
        date: []
      },
      columns1: [
        {
          title: '订单编号',
          key: 'order_no',
          minWidth: 200
        },
        {
          title: '标题',
          key: 'title',
          minWidth: 120,
          tooltip: true
        },
        {
          title: '购买人昵称',
          key: 'username',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '会员折扣',
          minWidth: 100,
          render: (h, params) => {
            if (params.row.vip_level == '球场萌新') {
              params.row.vip_level = '萌新'
            }
            if (params.row.vip_level) {
              if (params.row.vip_level.indexOf('会员') > -1) {
                params.row.vip_level = params.row.vip_level.replace('会员', '')
              }
            }
            return h(
              'span',
              {
                class: {
                  blue: true
                }
              },
              params.row.vip_level == '萌新'
                ? '无(萌新)'
                : params.row.vip_discount
                  ? params.row.vip_discount + ' (' + params.row.vip_level + ')'
                  : ''
            )
          }
        },
        {
          title: '实付款',
          key: 'money',
          minWidth: 80,
          align: 'center',
          render: (h, params) => {
            return h('span', {
              class: {
                red: true
              }
            }, params.row.money)
          }
        },
        {
          title: '手续费',
          key: 'money',
          minWidth: 80,
          align: 'center',
          render: (h, params) => {
            return h('span', {
              class: {
                red: true
              }
            }, (params.row.money * 6 / 1000).toFixed(2))
          }
        },
        {
          title: '结余费',
          key: 'money',
          minWidth: 80,
          align: 'center',
          render: (h, params) => {
            return h('span', {
              class: {
                red: true
              }
            }, (params.row.money - (params.row.money * 6 / 1000).toFixed(2)).toFixed(2))
          }
        },
        {
          title: '来源',
          key: 'applet_type',
          width: '170px',
          render: (h, params) => {
            if (params.row.applet_type === 1) {
              return h('span', {

              }, '内部分享')
            } else if (params.row.applet_type === 2) {
              return h('span', {

              }, '内部说')
            } else if (params.row.applet_type === 3) {
              return h('span', {

              }, '足球财富资讯')
            } else if (params.row.applet_type === 4) {
              return h('span', {
              }, '内部料')
            } else {
              return h('span', {
              }, '未知')
            }
          }

        },
        {
          title: '购买时间',
          minWidth: 180,
          key: 'create_time'
        },
        {
          title: '作者昵称',
          minWidth: 180,
          key: 'post_username'
        }
      ]
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    // 获取表格数据
    getTableData () {
      this.tableLoading = true
      let start_time = this.formData.date[0] ? this.formData.date[0] + ' 00:00:00' : ''
      let end_time = this.formData.date[1] ? this.formData.date[1] + ' 24:00:00' : ''

      this.$api.orderList({
        page_num: this.page_num,
        page_size: this.page_size,
        start_time,
        end_time,
        username: this.formData.input2, // 购买人昵称
        post_username: this.formData.input3, // 作者昵称
        title: this.formData.input1
      }).then(res => {
        if (res.code === 0) {
          this.tableData = res.data.list
          // 收入
          this.income = res.data.ext.sum_money
          this.total = res.data.total_row
        } else {
          this.$Message.error(res.msg)
        }
        this.tableLoading = false
      })
    },
    // 查询
    handleSearch () {
      // 有数据且搜索框一个不为空的时候执行搜索
      this.page_num = 1
      this.getTableData()
    },
    // 重置
    reset () {
      this.formData = Object.assign({}, this.formData1)
      this.handleSearch()
    }
  }
}
</script>

<style scoped lang="less">
  /deep/ .ivu-form-item{
    margin-bottom: 0;
  }
  .mytable-titleBox{
    width: 100%;
  }
  .checkReset:first-child {
    margin-right: 8px;
  }

  .ivu-modal-footer{
    border-top: none !important;
  }
  .shadowLine{
    width: 660px;
    height: 1px;
    background: #E9E9E9;
    margin: 24px 0;
  }
  .wechartBox{
    width: 282px;
    border: 1px solid #DCE1E6;
    border-radius: 4px;
    line-height: 32px;
    padding-left: 12px;
    span{
      width: 74px;
      text-align: center;
      border-left:  1px solid #DCE1E6;
      cursor: pointer;
    }
  }

  /deep/ .ivu-upload-drag{
    border: none;
    background: transparent;
  }
  /deep/ .textarea.ivu-input{
    min-height: 88px;
    height: 88px;
  }
  .playFont{
    color:#8A9299;
  }
  .boldTitle{
    color:#000;
    font-weight:bold;
    font-size: 14px;
  }
  .graybg{
    width: 724px;
    height: 12px;
    background: #F0F3F5;
    position: relative;
    left: -32px;
    margin-bottom: 24px;
    margin-top: 8px;
  }
  .shadowTitleClick span{
    cursor: pointer;
  }
  .income b{
    color: #FF5579;
    /*font-weight: bold;*/

  }
  .income{
    line-height: 32px;
    font-size: 16px;
  }
  @media screen and (max-width: 1400px) and (min-width: 1300px) {
    .mytable-title{
      margin-right: 10px;
    }
    .addAuthor{

    }
  }
</style>
